import { render, staticRenderFns } from "./AiResults.vue?vue&type=template&id=b8a10538&scoped=true"
import script from "./AiResults.vue?vue&type=script&lang=js"
export * from "./AiResults.vue?vue&type=script&lang=js"
import style0 from "./AiResults.vue?vue&type=style&index=0&id=b8a10538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a10538",
  null
  
)

export default component.exports